<template>
  <ReassuranceItem has-link @click="onClick">
    <template #icon>
      <IconBackMarketPromiseFilled class="h-24 w-24 md:h-32 md:w-32" />
    </template>
    <template #title>
      {{ i18n(translations.verified) }}
    </template>
  </ReassuranceItem>
</template>

<script lang="ts" setup>
import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'
import { useTracking } from '@backmarket/nuxt-module-tracking/useTracking'
import { openModal } from '@ds/components/ModalBase'
import { IconBackMarketPromiseFilled } from '@ds/icons/IconBackMarketPromiseFilled'

import { MODAL_NAMES } from '~/scopes/product-core/constants'

import ReassuranceItem from '../ReassuranceItem/ReassuranceItem.vue'

import translations from './ItemVerifiedRefurbished.translations'

const i18n = useI18n()
const { trackClick } = useTracking()

function onClick(event: MouseEvent) {
  openModal(MODAL_NAMES.VERIFIED_REFURBISHED, event)
  trackClick({
    zone: 'verified_refurbished_info',
    name: 'verified_refurbished',
  })
}
</script>
